import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import get from 'lodash/get'
import HorizontalRule from '../horizontal-rule'
import Spacer from '../spacer'
import RingDetails from './ring-details'
import PendantDetails from './pendant-details'
import StudEarringDetails from './stud-earring-details'
import StockItemDetails from './stock-item-details'

const renderDetails = (data) => {
  let jewelryType = get(data, 'jewellery_type')
  if (jewelryType === 'engagement_ring' || jewelryType === 'male_wedding_band' || jewelryType === 'female_wedding_band') {
    return <RingDetails data={data} />
  } else if (jewelryType === 'pendant') {
    return <PendantDetails data={data} />
  } else if (jewelryType === 'stud_earring') {
    return <StudEarringDetails data={data} />
  } else if (jewelryType === 'stock_item') {
    return <StockItemDetails data={data} />
  }
}

const JewelryDetails = props => (
  <div>
    <Spacer xs />
    {renderDetails(props.data)}
    <HorizontalRule>Additional Notes</HorizontalRule>
    <Spacer xs />
    <Grid>
      <GridItem col='1/2'>
        <DetailsItem title='' value={props.additionalNotes ? props.additionalNotes : '-'} />
      </GridItem>
      <GridItem col='1/2' />
    </Grid>
  </div>
)

JewelryDetails.propTypes = {
  data: PropTypes.object.isRequired
}

export default JewelryDetails



// WEBPACK FOOTER //
// ./src/components/jewelry-details/index.js